import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const offlineInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  if (!navigator.onLine) {
    return throwError(() => new HttpErrorResponse({ status: 0, statusText: 'Offline' }));
  }

  return next(req).pipe(
    catchError(err => {
      if (err instanceof HttpErrorResponse && (err.status === 0 || err.status === 503)) {
        // network error — caller handles gracefully
      }
      return throwError(() => err);
    })
  );
};
